import { Component } from '@angular/core';
import { PaymentTypes } from '@portal/entity-services/payment-contracts/src/lib/components/form/payment-type.list';
import { Subject } from 'rxjs';
import { ISelectInput } from '../box/interfaces/select-input.interface';
import { FILTER_CONTENT_ITEM } from '../content/token';
import { FilterBase } from '../filter-base';
import { SearchOperator } from '../search/enums/search-operator.enum';
import { SearchSelector } from '../search/enums/search-selector.enum';

declare const $localize;

@Component({
    selector: 'portal-shared-payment-type',
    templateUrl: './payment-type.component.html',
    providers: [
        {
            provide: FILTER_CONTENT_ITEM,
            useExisting: PaymentTypeComponent,
        },
    ],
    standalone: false
})
export class PaymentTypeComponent extends FilterBase {
  paymentTypesList: ISelectInput[] = this.paymentTypes.list;
  refreshRadioList$ = new Subject();
  paymentTypeText = $localize`Payment type`;
  searchSelector: string;

  constructor(private paymentTypes: PaymentTypes) {
    super(SearchSelector.PaymentType.toString(), paymentTypes.list);
    this.paymentTypesList = paymentTypes.list;
    this.searchSelector = SearchSelector.PaymentType.toString();
  }

  onEntityAdded(selectedEntity: ISelectInput): void {
    this.localPreSelectedEntities.clear();
    this.localPreSelectedEntities.set(selectedEntity.id, selectedEntity);
  }

  onFilterApplied(): void {
    this.updateEntities();
    const values: string[] = this.getValues();
    if (values.length) {
      this.filterApplied.emit({
        key: this.searchSelector,
        operator: SearchOperator.In,
        value: Array.from(this.localPreSelectedEntities.values()),
        argument: `(${Array.from(values).join(',')})`,
      });
      this.staticFilterUpdated.emit({
        key: this.searchSelector,
        value: Array.from(this.localPreSelectedEntities.values()),
      });
    } else {
      this.filterApplied.emit({
        key: this.searchSelector,
        toRemove: true,
      });
      this.staticFilterUpdated.emit({
        key: this.searchSelector,
        toRemove: true,
      });
    }

    this.updateText();
    this.itemToggled.emit();
  }

  removeAllEntities(): void {
    this.localPreSelectedEntities.clear();
    this.updateText();
    this.refreshRadioList$.next();
  }

  updateText(): void {
    const values: string[] = this.getValues();
    const text = $localize`Payment type`;
    if (values.length) {
      this.paymentTypeText = `${text} (+${values.length})`;
    } else {
      this.paymentTypeText = text;
    }
  }
}
